export const WELCOME_MESSAGE = {
  role: "assistant",
  content: "Hello! I'm your AI Sales Advisor. I can help you with strategies for closing deals, prioritizing accounts, or any sales question you have. What would you like to discuss?",
};

export const FALLBACK_REPLY = "I apologize, but I'm having trouble processing your request right now. Please try again.";

export const SUGGESTED_QUESTIONS = [
  "How do I close the deal faster?",
  "What accounts should I focus on this week?",
  "How can I improve my close ratio?",
  "What's the best approach for enterprise sales?",
];

export const RECENT_TOPICS = ["Deal acceleration", "Account prioritization", "Objection handling"];

export const QUICK_CONTEXT = [
  { label: "Active Accounts", value: "5" },
  { label: "Pipeline Value", value: "$343K" },
  { label: "This Week's Focus", value: "Close 2 deals", accent: true },
];
